import Utils from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";
import { InfoWindow } from "./InfoWindow";

export class HeartText extends InfoWindow {
  shiftX = 320;
  shiftY = 290;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  getExtraData(patient: Patient) {
    console.log("here!");
    // Blood Pressure
    let bp = _.get(patient, "body.atoms.bp.legend", "");
    let bpLabel = "BP"; // default
    if (bp.includes(" (Art Line)")) {
      if (this.supportsForeignObject) {
        bpLabel = "BP<sub>Art</sub>";
      } else {
        bpLabel = "BP (Art)";
      }
      bp = bp.replace(" (Art Line)", "");
    } else if (bp.includes(" (Cuff)")) {
      if (this.supportsForeignObject) {
        bpLabel = "BP<sub>Cuff</sub>";
      } else {
        bpLabel = "BP (Cuff)";
      }
      bp = bp.replace(" (Cuff)", "");
    }
    bp = bp ? [bpLabel, bp] : bp;

    // Edwards art-line Cardiac Index
    let artCardiacIndex = _.get(
      patient,
      "body.atoms.artCardiacIndex.legend",
      ""
    );
    let ciLabel = "CI";
    if (artCardiacIndex.includes("(CI)")) {
      ciLabel = "CI";
      artCardiacIndex = artCardiacIndex.replace("(CI)", "");
    } else if (artCardiacIndex.includes("(CO)")) {
      ciLabel = "CO";
      artCardiacIndex = artCardiacIndex.replace("(CO)", "");
    }
    artCardiacIndex = artCardiacIndex
      ? [ciLabel, artCardiacIndex]
      : artCardiacIndex;

    // Edwards art-line Stroke Volume
    let artStrokeVolumeIndexed = _.get(
      patient,
      "body.atoms.artStrokeVolumeIndexed.legend",
      ""
    );
    let sviLabel = "SVI";
    if (artStrokeVolumeIndexed.includes("(SVI)")) {
      sviLabel = "SVI";
      artStrokeVolumeIndexed = artStrokeVolumeIndexed.replace("(SVI)", "");
    } else if (artStrokeVolumeIndexed.includes("(SV)")) {
      sviLabel = "SV";
      artStrokeVolumeIndexed = artStrokeVolumeIndexed.replace("(SV)", "");
    }
    artStrokeVolumeIndexed = artStrokeVolumeIndexed
      ? [sviLabel, artStrokeVolumeIndexed]
      : artStrokeVolumeIndexed;

    // Edwards art-line SVRI
    let artSystemicVascularResistanceIndexed = _.get(
      patient,
      "body.atoms.artSystemicVascularResistanceIndexed.legend",
      ""
    );
    let svriLabel = "SVRI";
    if (artSystemicVascularResistanceIndexed.includes("(SVRI)")) {
      svriLabel = "SVRI";
      artSystemicVascularResistanceIndexed = artSystemicVascularResistanceIndexed.replace(
        "(SVRI)",
        ""
      );
    } else if (artSystemicVascularResistanceIndexed.includes("(SVR)")) {
      svriLabel = "SVR";
      artSystemicVascularResistanceIndexed = artSystemicVascularResistanceIndexed.replace(
        "(SVR)",
        ""
      );
    }
    artSystemicVascularResistanceIndexed = artSystemicVascularResistanceIndexed
      ? [svriLabel, artSystemicVascularResistanceIndexed]
      : artSystemicVascularResistanceIndexed;

    // Heart Rate
    let heartRate = _.get(patient, "body.atoms.heartRate.legend", "");
    let hrLabel = "HR"; // default
    if (heartRate.includes(" (SpO2)")) {
      if (this.supportsForeignObject) {
        hrLabel = "HR<sub>SpO<sub>2</sub></sub>";
      } else {
        hrLabel = "HR (SpO2)";
      }
      heartRate = heartRate.replace(" (SpO2)", "");
    } else if (heartRate.includes(" (EKG)")) {
      if (this.supportsForeignObject) {
        hrLabel = "HR<sub>EKG</sub>";
      } else {
        hrLabel = "HR (EKG)";
      }
      heartRate = heartRate.replace(" (EKG)", "");
    } else if (heartRate.includes(" (Epic)")) {
      if (this.supportsForeignObject) {
        hrLabel = "HR<sub>Epic</sub>";
      } else {
        hrLabel = "HR (Epic)";
      }
      heartRate = heartRate.replace(" (Epic)", "");
    } else if (heartRate.includes(" (ArtLine)")) {
      if (this.supportsForeignObject) {
        hrLabel = "HR<sub>Art</sub>";
      } else {
        hrLabel = "HR (Art)";
      }
      heartRate = heartRate.replace(" (ArtLine)", "");
    } else if (heartRate.includes(" (Cuff)")) {
      if (this.supportsForeignObject) {
        hrLabel = "HR<sub>Cuff</sub>";
      } else {
        hrLabel = "HR (Cuff)";
      }
      heartRate = heartRate.replace(" (Cuff)", "");
    }
    heartRate = heartRate ? [hrLabel, heartRate] : heartRate;

    // If empty will be ignored by InfoWindow, used for mindata
    // to show heart rate value on a second line
    let heartRate2 = "";
    if (patient.census.minDataPatient) {
      heartRate2 = heartRate[1].replace("]", " ago]");
      heartRate = "HR at Rest";
    }

    if (!this.supportsForeignObject) {
      heartRate[1] = heartRate[1].replace("<sub>2</sub>", "₂");
    }

    const dataToMap = {
      bp,
      heartRate,
      heartRate2,
      artCardiacIndex,
      artStrokeVolumeIndexed,
      artSystemicVascularResistanceIndexed
    };

    this.extraData = {
      tableData: Object.entries(dataToMap)
        .filter(([_key, item]) => {
          if (_.isArray(item)) {
            return item[1];
          } else {
            return item;
          }
        })
        .map(([key, item]) => {
          const level = _.get(patient, `body.atoms.${key}.level`);
          const color =
            level === 3 || level === 0 || level === -1
              ? ""
              : Utils.getLevelColor(level, this.showGreenGrayOnly);
          return { rows: item, color, level };
        })
    };
  }
}
